import gql from "graphql-tag";
const RESET_PASSWORD = gql`
  mutation setPasswordDashboardUser($username: String!, $permanent: Boolean) {
    setPasswordDashboardUser(username: $username, permanent: $permanent)
  }
`;

export default RESET_PASSWORD;
